import React, { useEffect } from "react"
import { injectFontImport } from "./font-loader"

export type FontPreviewProps = {
  /** Google Font family name */
  font: string
  /** Font weight to load */
  weight?: number
  /** Custom display label (defaults to font name) */
  label?: string
  /** Skip injecting a Google Fonts import (for system fonts) */
  noImport?: boolean
}

function FontPreview({ font, weight = 400, label, noImport }: FontPreviewProps) {
  const style = { fontFamily: font }

  useEffect(() => {
    if (!noImport) {
      injectFontImport(font, weight)
    }
  }, [font, weight, noImport])

  return <div style={style}>{label || font}</div>
}

export default FontPreview
